import { c as _c } from "react/compiler-runtime";
import { Typography } from '@/shared/ui/atoms';
import { PartnerHospitalUninsuredItem, PartnerHospitalEquipment } from '@/entities/hospital/api/types';
import { useTranslations } from 'next-intl';
interface HospitailTreatmentInfoProps {
  uninsuredItems: PartnerHospitalUninsuredItem[];
  equipments: PartnerHospitalEquipment[];
  /**
   * 새 상세 페이지의 섹션 셸 안에 들어갈 때. 제목과 바깥 여백은 섹션이 갖고 있으므로
   * 여기서는 내용만 그린다. 기본값(false)은 기존 상세 페이지의 모습 그대로다.
   */
  embedded?: boolean;
}
const HospitailTreatmentInfo = t0 => {
  const $ = _c(17);
  const {
    uninsuredItems,
    equipments,
    embedded: t1
  } = t0;
  const embedded = t1 === undefined ? false : t1;
  const t = useTranslations();
  const t2 = embedded ? undefined : "hospital-treatment";
  const t3 = embedded ? "" : "px-4 pb-[30px]";
  let t4;
  if ($[0] !== embedded || $[1] !== t) {
    t4 = embedded ? null : <Typography size={18} className="py-3 text-gray-900 font-bold">{t("treatmentInfo.title")}</Typography>;
    $[0] = embedded;
    $[1] = t;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t || $[4] !== uninsuredItems) {
    t5 = uninsuredItems && uninsuredItems.length > 0 && <div className="flex flex-col gap-2"><Typography size={16} className="py-2 text-gray-800 font-semibold">{t("treatmentInfo.uninsuredTitle")}</Typography><div className="flex flex-col border border-gray-200 rounded-lg overflow-hidden"><div className="flex items-center"><Typography size={14} lineHeight={20} className="w-[60%] pl-4 py-2 text-gray-700 font-medium break-keep border-r border-gray-200">{t("treatmentInfo.columns.type")}</Typography><Typography size={14} lineHeight={21} className="w-[40%] pl-4 py-2 text-gray-700 font-medium break-keep">{t("treatmentInfo.columns.price")}</Typography></div>{uninsuredItems.map(_temp)}</div></div>;
    $[3] = t;
    $[4] = uninsuredItems;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== equipments || $[7] !== t) {
    t6 = equipments && equipments.length > 0 && <div className="flex flex-col gap-2"><Typography size={16} className="py-2 text-gray-800 font-semibold">{t("treatmentInfo.equipmentTitle")}</Typography><div className="flex flex-col border border-gray-200 rounded-lg overflow-hidden"><div className="flex items-center"><Typography size={14} lineHeight={20} className="w-[60%] pl-4 py-2 text-gray-700 font-medium break-keep border-r border-gray-200">{t("treatmentInfo.columns.equipment")}</Typography><Typography size={14} lineHeight={21} className="w-[40%] pl-4 py-2 text-gray-700 font-medium break-keep">{t("treatmentInfo.columns.count")}</Typography></div>{equipments.map(_temp2)}</div></div>;
    $[6] = equipments;
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex flex-col gap-[30px]">{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t7) {
    t8 = <div id={t2} className={t3}>{t4}{t7}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default HospitailTreatmentInfo;
function _temp(item, index) {
  return <div key={`uninsured-item-${index}`} className="flex items-stretch"><Typography size={14} lineHeight={21} className={`w-[60%] flex items-center px-4 py-2 text-gray-800 font-semibold break-keep border-r border-gray-200 ${!(index % 2) ? "bg-gray-100" : "bg-white"}`}>{item.itemName}</Typography><Typography size={14} lineHeight={21} className={`w-[40%] flex items-center px-4 py-2 text-gray-800 font-semibold break-keep ${!(index % 2) ? "bg-gray-100" : "bg-white"}`}>{item.priceText}</Typography></div>;
}
function _temp2(item_0, index_0) {
  return <div key={`equipment-${index_0}`} className="flex items-stretch"><Typography size={14} lineHeight={21} className={`w-[60%] flex items-center px-4 py-2 text-gray-800 font-semibold break-keep border-r border-gray-200 ${!(index_0 % 2) ? "bg-gray-100" : "bg-white"}`}>{item_0.equipmentName}</Typography><Typography size={14} lineHeight={21} className={`w-[40%] flex items-center px-4 py-2 text-gray-800 font-semibold break-keep ${!(index_0 % 2) ? "bg-gray-100" : "bg-white"}`}>{item_0.equipmentCount}</Typography></div>;
}